import { useCallback, useState } from 'react';

export const useForceUpdate = () => {
  const [key, setKey] = useState(false);
  return {
    forceUpdateKey: key,
    forceUpdate: useCallback(() => setKey((old) => !old), []),
  };
};
